export const LOGO_URL =
  "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";

export const API_options = {
  method: "GET",
  headers: {
    accept: "application/json",
    Authorization:
      "Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiI0NjczY2JmMDUzNGVkZDkxNWI4MzM3MThkMDJkNjJkOCIsInN1YiI6IjY2NTVhMWVkYTI2NDkzNzhjYjFjYmJmOCIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.i7Nl8p97iSQjjjWWLCWPXWOb0PSeQV-UDAD1v_eghso",
  },
};
export const POSTER_CDN = "https://image.tmdb.org/t/p/w300/";

export const OPEN_API_KEY = "AIzaSyD6ZpYx7rlkD-qQgE0IMQUixWc50tDDy80";
